module.exports = __webpack_public_path__ + "img/intro_bigTitle.10e98c42.png";